/* This file is auto-generated, manual edits in this file will be overwritten! */
const FONTS = {
    T1: {
        T10Px: {
            Black900: {
                value: {
                    fontFamily: 'Inter-Black',
                    fontSize: 10.0,
                    fontWeight: '900',
                    letterSpacing: 0.0,
                    lineHeight: 11.72,
                },
            },
            Bold700: {
                value: {
                    fontFamily: 'Inter-Bold',
                    fontSize: 10.0,
                    fontWeight: '700',
                    letterSpacing: 0.0,
                    lineHeight: 11.72,
                },
            },
            ExtraBold800: {
                value: {
                    fontFamily: 'Inter-ExtraBold',
                    fontSize: 10.0,
                    fontWeight: '800',
                    letterSpacing: 0.0,
                    lineHeight: 11.72,
                },
            },
            Light300: {
                value: {
                    fontFamily: 'Inter-Light',
                    fontSize: 10.0,
                    fontWeight: '300',
                    letterSpacing: 0.0,
                    lineHeight: 11.72,
                },
            },
            Medium500: {
                value: {
                    fontFamily: 'Inter-Medium',
                    fontSize: 10.0,
                    fontWeight: '500',
                    letterSpacing: 0.0,
                    lineHeight: 11.72,
                },
            },
            Regular400: {
                value: {
                    fontFamily: 'Inter-Regular',
                    fontSize: 10.0,
                    fontWeight: '400',
                    letterSpacing: 0.0,
                    lineHeight: 11.72,
                },
            },
            SemiBold600: {
                value: {
                    fontFamily: 'Inter-SemiBold',
                    fontSize: 10.0,
                    fontWeight: '600',
                    letterSpacing: 0.0,
                    lineHeight: 11.72,
                },
            },
        },
        T12Px: {
            Black900: {
                value: {
                    fontFamily: 'Inter-Black',
                    fontSize: 12.0,
                    fontWeight: '900',
                    letterSpacing: 0.0,
                    lineHeight: 14.06,
                },
            },
            Bold700: {
                value: {
                    fontFamily: 'Inter-Bold',
                    fontSize: 12.0,
                    fontWeight: '700',
                    letterSpacing: 0.0,
                    lineHeight: 14.06,
                },
            },
            ExtraBold800: {
                value: {
                    fontFamily: 'Inter-ExtraBold',
                    fontSize: 12.0,
                    fontWeight: '800',
                    letterSpacing: 0.0,
                    lineHeight: 14.06,
                },
            },
            Light300: {
                value: {
                    fontFamily: 'Inter-Light',
                    fontSize: 12.0,
                    fontWeight: '300',
                    letterSpacing: 0.0,
                    lineHeight: 14.06,
                },
            },
            Medium500: {
                value: {
                    fontFamily: 'Inter-Medium',
                    fontSize: 12.0,
                    fontWeight: '500',
                    letterSpacing: 0.0,
                    lineHeight: 14.06,
                },
            },
            Regular400: {
                value: {
                    fontFamily: 'Inter-Regular',
                    fontSize: 12.0,
                    fontWeight: '400',
                    letterSpacing: 0.0,
                    lineHeight: 14.06,
                },
            },
            SemiBold600: {
                value: {
                    fontFamily: 'Inter-SemiBold',
                    fontSize: 12.0,
                    fontWeight: '600',
                    letterSpacing: 0.0,
                    lineHeight: 14.06,
                },
            },
        },
        T14Px: {
            Black900: {
                value: {
                    fontFamily: 'Inter-Black',
                    fontSize: 14.0,
                    fontWeight: '900',
                    letterSpacing: 0.0,
                    lineHeight: 16.41,
                },
            },
            Bold: {
                value: {
                    fontFamily: 'Inter-Bold',
                    fontSize: 14.0,
                    fontWeight: '700',
                    letterSpacing: 0.0,
                    lineHeight: 16.41,
                },
            },
            ExtraBold800: {
                value: {
                    fontFamily: 'Inter-ExtraBold',
                    fontSize: 14.0,
                    fontWeight: '800',
                    letterSpacing: 0.0,
                    lineHeight: 16.41,
                },
            },
            Light300: {
                value: {
                    fontFamily: 'Inter-Light',
                    fontSize: 14.0,
                    fontWeight: '300',
                    letterSpacing: 0.0,
                    lineHeight: 16.41,
                },
            },
            Medium500: {
                value: {
                    fontFamily: 'Inter-Medium',
                    fontSize: 14.0,
                    fontWeight: '500',
                    letterSpacing: 0.0,
                    lineHeight: 16.41,
                },
            },
            Regular400: {
                value: {
                    fontFamily: 'Inter-Regular',
                    fontSize: 14.0,
                    fontWeight: '400',
                    letterSpacing: 0.0,
                    lineHeight: 16.41,
                },
            },
            SemiBold600: {
                value: {
                    fontFamily: 'Inter-SemiBold',
                    fontSize: 14.0,
                    fontWeight: '600',
                    letterSpacing: 0.0,
                    lineHeight: 16.41,
                },
            },
        },
        T16Px: {
            Black900: {
                value: {
                    fontFamily: 'Inter-Black',
                    fontSize: 16.0,
                    fontWeight: '900',
                    letterSpacing: 0.0,
                    lineHeight: 18.75,
                },
            },
            Bold700: {
                value: {
                    fontFamily: 'Inter-Bold',
                    fontSize: 16.0,
                    fontWeight: '700',
                    letterSpacing: 0.0,
                    lineHeight: 18.75,
                },
            },
            ExtraBold800: {
                value: {
                    fontFamily: 'Inter-ExtraBold',
                    fontSize: 16.0,
                    fontWeight: '800',
                    letterSpacing: 0.0,
                    lineHeight: 18.75,
                },
            },
            Light300: {
                value: {
                    fontFamily: 'Inter-Light',
                    fontSize: 16.0,
                    fontWeight: '300',
                    letterSpacing: 0.0,
                    lineHeight: 18.75,
                },
            },
            Medium500: {
                value: {
                    fontFamily: 'Inter-Medium',
                    fontSize: 16.0,
                    fontWeight: '500',
                    letterSpacing: 0.0,
                    lineHeight: 18.75,
                },
            },
            Regular400: {
                value: {
                    fontFamily: 'Inter-Regular',
                    fontSize: 16.0,
                    fontWeight: '400',
                    letterSpacing: 0.0,
                    lineHeight: 18.75,
                },
            },
            SemiBold600: {
                value: {
                    fontFamily: 'Inter-SemiBold',
                    fontSize: 16.0,
                    fontWeight: '600',
                    letterSpacing: 0.0,
                    lineHeight: 18.75,
                },
            },
        },
        T20Px: {
            Black900: {
                value: {
                    fontFamily: 'Inter-Black',
                    fontSize: 20.0,
                    fontWeight: '900',
                    letterSpacing: 0.0,
                    lineHeight: 23.44,
                },
            },
            Bold700: {
                value: {
                    fontFamily: 'Inter-Bold',
                    fontSize: 20.0,
                    fontWeight: '700',
                    letterSpacing: 0.0,
                    lineHeight: 23.44,
                },
            },
            ExtraBold800: {
                value: {
                    fontFamily: 'Inter-ExtraBold',
                    fontSize: 20.0,
                    fontWeight: '800',
                    letterSpacing: 0.0,
                    lineHeight: 23.44,
                },
            },
            Light300: {
                value: {
                    fontFamily: 'Inter-Light',
                    fontSize: 20.0,
                    fontWeight: '300',
                    letterSpacing: 0.0,
                    lineHeight: 23.44,
                },
            },
            Medium500: {
                value: {
                    fontFamily: 'Inter-Medium',
                    fontSize: 20.0,
                    fontWeight: '500',
                    letterSpacing: 0.0,
                    lineHeight: 23.44,
                },
            },
            Regular400: {
                value: {
                    fontFamily: 'Inter-Regular',
                    fontSize: 20.0,
                    fontWeight: '400',
                    letterSpacing: 0.0,
                    lineHeight: 23.44,
                },
            },
            SemiBold600: {
                value: {
                    fontFamily: 'Inter-SemiBold',
                    fontSize: 20.0,
                    fontWeight: '600',
                    letterSpacing: 0.0,
                    lineHeight: 23.44,
                },
            },
        },
        T24Px: {
            Black900: {
                value: {
                    fontFamily: 'Inter-Black',
                    fontSize: 24.0,
                    fontWeight: '900',
                    letterSpacing: 0.0,
                    lineHeight: 28.12,
                },
            },
            Bold700: {
                value: {
                    fontFamily: 'Inter-Bold',
                    fontSize: 24.0,
                    fontWeight: '700',
                    letterSpacing: 0.0,
                    lineHeight: 28.12,
                },
            },
            ExtraBold800: {
                value: {
                    fontFamily: 'Inter-ExtraBold',
                    fontSize: 24.0,
                    fontWeight: '800',
                    letterSpacing: 0.0,
                    lineHeight: 28.12,
                },
            },
            Light300: {
                value: {
                    fontFamily: 'Inter-Light',
                    fontSize: 24.0,
                    fontWeight: '300',
                    letterSpacing: 0.0,
                    lineHeight: 28.12,
                },
            },
            Medium500: {
                value: {
                    fontFamily: 'Inter-Medium',
                    fontSize: 24.0,
                    fontWeight: '500',
                    letterSpacing: 0.0,
                    lineHeight: 28.12,
                },
            },
            Regular400: {
                value: {
                    fontFamily: 'Inter-Regular',
                    fontSize: 24.0,
                    fontWeight: '400',
                    letterSpacing: 0.0,
                    lineHeight: 28.12,
                },
            },
            Semibold: {
                value: {
                    fontFamily: 'Inter-SemiBold',
                    fontSize: 24.0,
                    fontWeight: '400',
                    letterSpacing: 0.0,
                    lineHeight: 28.12,
                },
            },
        },
        T28Px: {
            Black900: {
                value: {
                    fontFamily: 'Inter-Black',
                    fontSize: 28.0,
                    fontWeight: '900',
                    letterSpacing: 0.0,
                    lineHeight: 32.81,
                },
            },
            Bold700: {
                value: {
                    fontFamily: 'Inter-Bold',
                    fontSize: 28.0,
                    fontWeight: '700',
                    letterSpacing: 0.0,
                    lineHeight: 32.81,
                },
            },
            ExtraBold800: {
                value: {
                    fontFamily: 'Inter-ExtraBold',
                    fontSize: 28.0,
                    fontWeight: '800',
                    letterSpacing: 0.0,
                    lineHeight: 32.81,
                },
            },
            Light300: {
                value: {
                    fontFamily: 'Inter-Light',
                    fontSize: 28.0,
                    fontWeight: '300',
                    letterSpacing: 0.0,
                    lineHeight: 32.81,
                },
            },
            Medium500: {
                value: {
                    fontFamily: 'Inter-Medium',
                    fontSize: 28.0,
                    fontWeight: '500',
                    letterSpacing: 0.0,
                    lineHeight: 32.81,
                },
            },
            Regular400: {
                value: {
                    fontFamily: 'Inter-Regular',
                    fontSize: 28.0,
                    fontWeight: '400',
                    letterSpacing: 0.0,
                    lineHeight: 32.81,
                },
            },
            SemiBold600: {
                value: {
                    fontFamily: 'Inter-SemiBold',
                    fontSize: 28.0,
                    fontWeight: '600',
                    letterSpacing: 0.0,
                    lineHeight: 32.81,
                },
            },
        },
        T32Px: {
            Black900: {
                value: {
                    fontFamily: 'Inter-Black',
                    fontSize: 32.0,
                    fontWeight: '900',
                    letterSpacing: 0.0,
                    lineHeight: 37.5,
                },
            },
            Bold700: {
                value: {
                    fontFamily: 'Inter-Bold',
                    fontSize: 32.0,
                    fontWeight: '700',
                    letterSpacing: 0.0,
                    lineHeight: 37.5,
                },
            },
            ExtraBold800: {
                value: {
                    fontFamily: 'Inter-ExtraBold',
                    fontSize: 32.0,
                    fontWeight: '800',
                    letterSpacing: 0.0,
                    lineHeight: 37.5,
                },
            },
            Light300: {
                value: {
                    fontFamily: 'Inter-Light',
                    fontSize: 32.0,
                    fontWeight: '300',
                    letterSpacing: 0.0,
                    lineHeight: 37.5,
                },
            },
            Medium500: {
                value: {
                    fontFamily: 'Inter-Medium',
                    fontSize: 32.0,
                    fontWeight: '500',
                    letterSpacing: 0.0,
                    lineHeight: 37.5,
                },
            },
            Regular400: {
                value: {
                    fontFamily: 'Inter-Regular',
                    fontSize: 32.0,
                    fontWeight: '400',
                    letterSpacing: 0.0,
                    lineHeight: 37.5,
                },
            },
            SemiBold600: {
                value: {
                    fontFamily: 'Inter-SemiBold',
                    fontSize: 32.0,
                    fontWeight: '600',
                    letterSpacing: 0.0,
                    lineHeight: 37.5,
                },
            },
        },
        T36Px: {
            Black900: {
                value: {
                    fontFamily: 'Inter-Black',
                    fontSize: 36.0,
                    fontWeight: '900',
                    letterSpacing: 0.0,
                    lineHeight: 42.19,
                },
            },
            Bold700: {
                value: {
                    fontFamily: 'Inter-Bold',
                    fontSize: 36.0,
                    fontWeight: '700',
                    letterSpacing: 0.0,
                    lineHeight: 42.19,
                },
            },
            ExtraBold800: {
                value: {
                    fontFamily: 'Inter-ExtraBold',
                    fontSize: 36.0,
                    fontWeight: '800',
                    letterSpacing: 0.0,
                    lineHeight: 42.19,
                },
            },
            Light300: {
                value: {
                    fontFamily: 'Inter-Light',
                    fontSize: 36.0,
                    fontWeight: '300',
                    letterSpacing: 0.0,
                    lineHeight: 42.19,
                },
            },
            Medium500: {
                value: {
                    fontFamily: 'Inter-Medium',
                    fontSize: 36.0,
                    fontWeight: '500',
                    letterSpacing: 0.0,
                    lineHeight: 42.19,
                },
            },
            Regular400: {
                value: {
                    fontFamily: 'Inter-Regular',
                    fontSize: 36.0,
                    fontWeight: '400',
                    letterSpacing: 0.0,
                    lineHeight: 42.19,
                },
            },
            SemiBold600: {
                value: {
                    fontFamily: 'Inter-SemiBold',
                    fontSize: 36.0,
                    fontWeight: '600',
                    letterSpacing: 0.0,
                    lineHeight: 42.19,
                },
            },
        },
        T40Px: {
            Black900: {
                value: {
                    fontFamily: 'Inter-Black',
                    fontSize: 40.0,
                    fontWeight: '900',
                    letterSpacing: 0.0,
                    lineHeight: 46.88,
                },
            },
            Bold700: {
                value: {
                    fontFamily: 'Inter-Bold',
                    fontSize: 40.0,
                    fontWeight: '700',
                    letterSpacing: 0.0,
                    lineHeight: 46.88,
                },
            },
            ExtraBold800: {
                value: {
                    fontFamily: 'Inter-ExtraBold',
                    fontSize: 40.0,
                    fontWeight: '800',
                    letterSpacing: 0.0,
                    lineHeight: 46.88,
                },
            },
            Light300: {
                value: {
                    fontFamily: 'Inter-Light',
                    fontSize: 40.0,
                    fontWeight: '300',
                    letterSpacing: 0.0,
                    lineHeight: 46.88,
                },
            },
            Medium500: {
                value: {
                    fontFamily: 'Inter-Medium',
                    fontSize: 40.0,
                    fontWeight: '500',
                    letterSpacing: 0.0,
                    lineHeight: 46.88,
                },
            },
            Regular400: {
                value: {
                    fontFamily: 'Inter-Regular',
                    fontSize: 40.0,
                    fontWeight: '400',
                    letterSpacing: 0.0,
                    lineHeight: 46.88,
                },
            },
            SemiBold600: {
                value: {
                    fontFamily: 'Inter-SemiBold',
                    fontSize: 40.0,
                    fontWeight: '600',
                    letterSpacing: 0.0,
                    lineHeight: 46.88,
                },
            },
        },
        T44Px: {
            Black900: {
                value: {
                    fontFamily: 'Inter-Black',
                    fontSize: 44.0,
                    fontWeight: '900',
                    letterSpacing: 0.0,
                    lineHeight: 51.56,
                },
            },
            Bold700: {
                value: {
                    fontFamily: 'Inter-Bold',
                    fontSize: 44.0,
                    fontWeight: '700',
                    letterSpacing: 0.0,
                    lineHeight: 51.56,
                },
            },
            ExtraBold800: {
                value: {
                    fontFamily: 'Inter-ExtraBold',
                    fontSize: 44.0,
                    fontWeight: '800',
                    letterSpacing: 0.0,
                    lineHeight: 51.56,
                },
            },
            Light300: {
                value: {
                    fontFamily: 'Inter-Light',
                    fontSize: 44.0,
                    fontWeight: '300',
                    letterSpacing: 0.0,
                    lineHeight: 51.56,
                },
            },
            Medium500: {
                value: {
                    fontFamily: 'Inter-Medium',
                    fontSize: 44.0,
                    fontWeight: '500',
                    letterSpacing: 0.0,
                    lineHeight: 51.56,
                },
            },
            Regular400: {
                value: {
                    fontFamily: 'Inter-Regular',
                    fontSize: 44.0,
                    fontWeight: '400',
                    letterSpacing: 0.0,
                    lineHeight: 51.56,
                },
            },
            SemiBold600: {
                value: {
                    fontFamily: 'Inter-SemiBold',
                    fontSize: 44.0,
                    fontWeight: '600',
                    letterSpacing: 0.0,
                    lineHeight: 51.56,
                },
            },
        },
        T60Px: {
            Black900: {
                value: {
                    fontFamily: 'Inter-Black',
                    fontSize: 60.0,
                    fontWeight: '900',
                    letterSpacing: 0.0,
                    lineHeight: 70.31,
                },
            },
            Bold700: {
                value: {
                    fontFamily: 'Inter-Bold',
                    fontSize: 60.0,
                    fontWeight: '700',
                    letterSpacing: 0.0,
                    lineHeight: 70.31,
                },
            },
            ExtraBold800: {
                value: {
                    fontFamily: 'Inter-ExtraBold',
                    fontSize: 60.0,
                    fontWeight: '800',
                    letterSpacing: 0.0,
                    lineHeight: 70.31,
                },
            },
            Light300: {
                value: {
                    fontFamily: 'Inter-Light',
                    fontSize: 60.0,
                    fontWeight: '300',
                    letterSpacing: 0.0,
                    lineHeight: 70.31,
                },
            },
            Medium500: {
                value: {
                    fontFamily: 'Inter-Medium',
                    fontSize: 60.0,
                    fontWeight: '500',
                    letterSpacing: 0.0,
                    lineHeight: 70.31,
                },
            },
            Regular400: {
                value: {
                    fontFamily: 'Inter-Regular',
                    fontSize: 60.0,
                    fontWeight: '400',
                    letterSpacing: 0.0,
                    lineHeight: 70.31,
                },
            },
            SemiBold600: {
                value: {
                    fontFamily: 'Inter-SemiBold',
                    fontSize: 60.0,
                    fontWeight: '600',
                    letterSpacing: 0.0,
                    lineHeight: 70.31,
                },
            },
        },
        T80Px: {
            Black900: {
                value: {
                    fontFamily: 'Inter-Black',
                    fontSize: 80.0,
                    fontWeight: '900',
                    letterSpacing: 0.0,
                    lineHeight: 93.75,
                },
            },
            Bold700: {
                value: {
                    fontFamily: 'Inter-Bold',
                    fontSize: 80.0,
                    fontWeight: '700',
                    letterSpacing: 0.0,
                    lineHeight: 93.75,
                },
            },
            ExtraBold800: {
                value: {
                    fontFamily: 'Inter-ExtraBold',
                    fontSize: 80.0,
                    fontWeight: '800',
                    letterSpacing: 0.0,
                    lineHeight: 93.75,
                },
            },
            Light300: {
                value: {
                    fontFamily: 'Inter-Light',
                    fontSize: 80.0,
                    fontWeight: '300',
                    letterSpacing: 0.0,
                    lineHeight: 93.75,
                },
            },
            Medium500: {
                value: {
                    fontFamily: 'Inter-Medium',
                    fontSize: 80.0,
                    fontWeight: '500',
                    letterSpacing: 0.0,
                    lineHeight: 93.75,
                },
            },
            Regular400: {
                value: {
                    fontFamily: 'Inter-Regular',
                    fontSize: 80.0,
                    fontWeight: '400',
                    letterSpacing: 0.0,
                    lineHeight: 93.75,
                },
            },
            SemiBold600: {
                value: {
                    fontFamily: 'Inter-SemiBold',
                    fontSize: 80.0,
                    fontWeight: '600',
                    letterSpacing: 0.0,
                    lineHeight: 93.75,
                },
            },
        },
    },
};
export default FONTS;
